
import { errorHandler } from '~/services/promiseErrors';

export default {
    computed: {
        isAndroidApp() {
            return process.client && document.referrer.includes('android-app://com.taftech.clearwaste');
        },
        isIosApp() {
            return process.client && window.LaunchReview;
        },
        isApp() {
            return this.isAndroidApp || this.isIosApp;
        },
        reviewUrl() {
            if (this.isIosApp) {
                return '#';
            }
            return 'https://play.google.com/store/apps/details?id=com.taftech.clearwaste';
        },
    },
    methods: {
        addReview(event) {
            if (this.isIosApp) {
                event.preventDefault();
                window.LaunchReview.launch(null, (error) => {
                    errorHandler(this, error);
                }, this.$config.appStore.apple.replace(/^.+\/id(\d+)$/, '$1'));
            }

            return true;
        },
    },
};

